<template>
  <div
    class="moreHonor"
    :class="[isHistory ? 'isHistory' : '']"
  >
    <div class="result-module">
      <section>
        <header>
          <titleBar title="战队荣誉" />
        </header>
        <div class="list">
          <div class="item" v-for="(item, index) in honorList" :key="index">
            <honorModule :honorData="item" @shareClick="shareClick" :numbers="'zhanduirongyus'+index"/>
          </div>
        </div>
      </section>
    </div>
    <van-popup style="width: 100%" v-model="isShowStarMemberPopUpDialog">
      <battalionPoster
        :posterUrl="starMemberPoster.posterUrl"
        :isShow="starMemberPoster.isShow"
        @OnCancelPoster="handleCancelStarMemberPoster"
      >
        <div id="starMemberPosterContainer">
          <star-member
            :isMVP="true"
            :teamInfo="teamInfo"
            :posterData="starMemberPosterData"
            v-if="starMemberPoster.isPoster == 1"
          ></star-member>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog">
      <battalionPoster
        :posterUrl="teamHonorPoster.posterUrl"
        :isShow="teamHonorPoster.isShow"
        @OnCancelPoster="handleCancelTeamHonorPoster"
      >
        <div id="teamHonorPosterContainer">
          <team-honor
            :teamInfo="teamInfo"
            :posterData="teamHonorPosterData"
            v-if="teamHonorPoster.isPoster == 1"
          ></team-honor>
        </div>
      </battalionPoster>
    </van-popup>
  </div>
</template>

<script>
import titleBar from "./components/titleBar.vue";
import shareBtn from "./components/shareBtn.vue";
import normalModule from "./components/normalModule.vue";
import honorModule from "./components/honorModule.vue";
import { eventHomePage } from "../../api/winterGame";
import {
  formatDateStr,
  getHonorDesc,
  getTeamHonorPosterData,
} from "../../util/util";
import { Toast } from "vant";
import html2canvas from "html2canvas";
import battalionPoster from "@components/SquirrelCupII/battalion-poster.vue";
import StarMember from "@views/WinterGame/components/poster/starMember.vue";
import TeamHonor from "@views/WinterGame/components/poster/teamHonor.vue";
import { gethonorDescMapConfig } from "@/util/config";
import { judgeTempSeason } from "@/util/util.js";
export default {
  components: {
    TeamHonor,
    StarMember,
    battalionPoster,
    titleBar,
    shareBtn,
    normalModule,
    honorModule,
  },
  data() {
    return {
      isHistory: false,
      isShowStarMemberPopUpDialog: false,
      isShowPopUpDialog: false,
      starMemberPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      teamHonorPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      teamInfo: {
        teamName: "",
        servicePointName: "",
      },
      starMemberPosterData: null,
      teamHonorPosterData: null,
      currentCampusId: 88,
      currentUserId: 98,
      honorList: [],
      // 战队荣耀 :1最强战队2连胜战队3最精彩的比赛4满勤战队5最强战队（赛季）6冠军战队7亚军战队8季军战队9战队MVP学员
      honorDescMap: gethonorDescMapConfig(),
      scheduleId: "",
      seasonId: "",
      isSpring: false,
    };
  },
  mounted() {
    if (this.$route.query.isHistory == 1) {
      this.isHistory = true;
      this.scheduleId = this.$route.query.scheduleId;
      this.seasonId = this.$route.query.seasonId;
    }
    this.initTeamInfo();
    this.setUserInfo();
    if (this.currentUserId) {
      this.eventHomePage();
    }
    //查询当前的临时的赛季
    const [isSpring, year, season] = judgeTempSeason(false);
    this.isSpring = isSpring;
  },

  methods: {
    getWinNum(wining_num) {
      let text = "";
      switch (wining_num) {
        case 3:
          text = "三";
          break;
        case 4:
          text = "四";
          break;
        case 5:
          text = "五";
          break;
        case 6:
          text = "六";
          break;
        case 7:
          text = "七";
          break;
        case 8:
          text = "八";
          break;
        case 9:
          text = "九";
          break;
      }
      return text;
    },
    shareClick(data) {
      // 1最强战队2连胜战队3最精彩的比赛4满勤战队5最强战队（赛季）6冠军战队7亚军战队8季军战队9战队MVP学员10战区单日最强战队
      if (data.type == 9) {
        // 9战队MVP学员
        this.starMemberPosterData = {
          realName: data.honorDesc.userName,
          cupNumber: data.honorDesc.cupNumber,
          date: data.day,
        };
        // 明星学员海报
        this.lookStarMemberPoster();
      } else {
        // 通用海报
        this.teamHonorPosterData = getTeamHonorPosterData(data, this.teamInfo);
        this.lookTeamHonorPoster();
      }
    },
    handleCancelStarMemberPoster(type) {
      this.starMemberPoster.isShow = type;
      this.isShowStarMemberPopUpDialog = false;
    },
    handleCancelTeamHonorPoster(type) {
      this.teamHonorPoster.isShow = type;
      this.isShowPopUpDialog = false;
    },
    // 查看团队荣誉海报
    lookTeamHonorPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.teamHonorPoster.isPoster = 1;
      this.isShowPopUpDialog = true;
      setTimeout(() => {
        const dom = document.querySelector("#teamHonorPosterContainer");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.teamHonorPoster.isPoster = -1;
          this.teamHonorPoster.isShow = true;
          this.teamHonorPoster.posterUrl = canvas.toDataURL();
          Toast('长按保存图片');;
          // gio("track", "onShareBattleReport", { onSharePosters: "ShareLogo" });
        });
      }, 500);
    },
    lookStarMemberPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.starMemberPoster.isPoster = 1;
      this.isShowStarMemberPopUpDialog = true;
      setTimeout(() => {
        const dom = document.querySelector("#starMemberPosterContainer");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.starMemberPoster.isShow = true;
          this.starMemberPoster.posterUrl = canvas.toDataURL();
          this.starMemberPoster.isPoster = -1;
          Toast('长按保存图片');;
          // gio("track", "onShareBattleReport", { onSharePosters: "ShareLogo" });
        });
      }, 500);
    },
    initTeamInfo() {
      let teamInfoKey = "teamInfo";
      if (this.isHistory) {
        teamInfoKey = "historyTeamInfo";
      }
      let teamInfo = localStorage.getItem(teamInfoKey);
      this.teamInfo = JSON.parse(teamInfo);
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentCampusId = userInfoId.campusId;
        this.currentUserId = userInfoId.agentUserId;
      } else {
        Toast("找不到参赛信息");
      }
    },
    async eventHomePage() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          last_id: 0, //最后一个主建ID，分页用
          page_size: 100,
          scheduleId: this.scheduleId,
          seasonId: this.seasonId,
        },
      };
      let res = await eventHomePage(params);

      if (res.code == 0) {
        let arr = [];
        res.data.forEach((item) => {
          //统一方法
          item = getHonorDesc(item, this.honorDescMap, this.teamInfo);
          item.day = formatDateStr(item.day);
          arr.push(item);
        });
        this.honorList = arr;
      } else {
        Toast(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.moreHonor {
  width: 100%;
  height: 100%;
  padding-top: 32px;
  &.isHistory {
    &.autumn_2023 {
      background: linear-gradient(180deg, #6b3510 0%, #865d30 100%);
    }
    &.summer_2023 {
      background: linear-gradient(180deg, #0059c7 0%, #0098ff 100%);
    }
    // 春季赛
    &.spring_2023 {
      background: linear-gradient(180deg, #00236d 0%, #001d46 100%);
    }
    &.winter_2024 {
      background: linear-gradient(180deg, #2BA8F6 0%, #3F85EF 100%);
    }
  }
  .springBanner {
    img {
      width: 100%;
    }
  }

  .result-module {
    header {
      margin-bottom: 16px;
    }
    .list {
      .item {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
